import { useState, useEffect } from "react";
import ScoutingReportManager from "../../../managers/ScoutingReportsManager";
import { toDivisionApi } from "../../../config/constants";
import { buildPositionMap, fetchHeadshotMap } from "../services/depth-chart-service";

export function useDepthChart(reportId) {
  const [report, setReport] = useState(null);
  const [positionMap, setPositionMap] = useState({});
  const [headshotMap, setHeadshotMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!reportId) return;

    const load = async () => {
      try {
        setLoading(true);
        const reportData = await ScoutingReportManager.getReportById(reportId);
        setReport(reportData);
        if (!reportData) return;

        const players = reportData.positionPlayers || [];
        const division = toDivisionApi(reportData.division);

        const [map, headshots] = await Promise.all([
          buildPositionMap(players, reportData.year, division),
          fetchHeadshotMap(players.map((p) => p.id)),
        ]);

        setPositionMap(map);
        setHeadshotMap(headshots);
      } catch (err) {
        console.error("Error loading depth chart:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [reportId]);

  return { report, positionMap, headshotMap, loading };
}
